export default __webpack_public_path__ + "static/media/033-bm.05e6a227.webp";